export interface ExperienceLevel {
  name: string;
  value: string;
}

export const experienceLevels: ExperienceLevel[] = [
  {
    name: "מתחיל",
    value: "BEGINNER_ADVANCE"
  },
  {
    name: "בינוני",
    value: "MEDIUM"
  },
  {
    name: "מקצוען",
    value: "ADVANCE"
  },
]
